import { styled } from "@mui/material";

export const Dropdown = styled("div")`
  padding: 1rem;
`;
